import React from 'react';
import styled from 'styled-components';

import AiNoticeBanner from '@/components/templates/mobile/home/HomeSearchTemplate/components/HomeDiseaseSymptomSearch/components/AiNoticeBanner';
import SymptomResultSection from '@/components/templates/mobile/home/HomeSearchTemplate/components/HomeDiseaseSymptomSearch/components/SymptomResultSection';
import RecentKeyword from '@/components/templates/mobile/home/HomeSearchTemplate/components/RecentKeyword';
import { HomeSearchKeywordList } from '@/types/search';

type Props = {
  entryType?: string;
  popularSymptomList: Array<{
    symptomName: string;
    symptomPublicId: string;
  }>;
  handleSymptomKeywordClick: (keyword: string) => void;
  handleSearchDirectKeyword: (keyword: string) => void;
  recentKeywordViewData: HomeSearchKeywordList;
  handleDeleteItemRecentKeyword: (keyword: string) => void;
  handleDeleteAllRecentKeyword: () => void;
};

const HomeDiseaseSymptomSearch = (props: Props) => {
  const {
    entryType,
    popularSymptomList,
    handleSymptomKeywordClick,
    handleSearchDirectKeyword,
    handleDeleteItemRecentKeyword,
    handleDeleteAllRecentKeyword,
    recentKeywordViewData,
  } = props;

  return (
    <>
      {entryType === 'symptom' && <AiNoticeBanner />}
      <>
        {entryType !== 'symptom' && recentKeywordViewData.length > 0 && (
          <RecentKeyword
            onSearchDirectKeyword={handleSearchDirectKeyword}
            recentKeywordViewData={recentKeywordViewData}
            onDeleteItemRecentKeyword={handleDeleteItemRecentKeyword}
            onDeleteAllRecentKeyword={handleDeleteAllRecentKeyword}
          />
        )}
        <SymptomResultSection title={'인기 검색어'}>
          <SymptomResultSection.Result>
            <PopularSearchSymptomKeywordContainer>
              {popularSymptomList.map((symptom: { symptomName: string; symptomPublicId: string }, index: number) => {
                return (
                  <PopularSearchSymptomKeyword
                    key={symptom.symptomPublicId}
                    onClick={() => handleSymptomKeywordClick(symptom.symptomName)}
                  >
                    <PopularSearchSymptomKeywordIndex>{index + 1}</PopularSearchSymptomKeywordIndex>
                    <PopularSearchSymptomKeywordContent>{symptom.symptomName}</PopularSearchSymptomKeywordContent>
                  </PopularSearchSymptomKeyword>
                );
              })}
            </PopularSearchSymptomKeywordContainer>
          </SymptomResultSection.Result>
        </SymptomResultSection>
      </>
    </>
  );
};

export default HomeDiseaseSymptomSearch;

const PopularSearchSymptomKeywordContainer = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 24px 16px;
  margin: 0;
`;

const PopularSearchSymptomKeyword = styled.button`
  border: none;
  width: 100%;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const PopularSearchSymptomKeywordIndex = styled.span`
  color: ${({ theme }) => theme.color.primary700};
  ${({ theme }) => theme.typography.UI15SB};
  display: flex;
  text-align: left;
  width: 20px;
  height: 20px;
  align-items: center;
`;

const PopularSearchSymptomKeywordContent = styled.span`
  color: ${({ theme }) => theme.color.gray700};
  ${({ theme }) => theme.typography.UI17SB};
  display: inline-flex;
  align-items: center;
  height: 30px;
  margin-left: 8px;
  text-align: left;
`;
